import Vue from 'vue';
import Vuex from 'vuex';
import {
  ADD_SAMPLE, 
  GET_SAMPLES, 
  UPDATE_SAMPLE,
  DELETE_SAMPLE,
  SET_TOKEN,
  SET_ADMIN,
  GET_FOLDERS,
  CREATE_FOLDER,
  SELECT_FOLDER,

  ADD_LIGHT,
  ADD_PANEL_TEMPERATURE,
  CLEAR_LIGHTS,
  CLEAR_PANEL_TEMPERATURES,
  SET_LIGHT,
  SET_PANEL_TEMPERATURE,
  SET_SENSOR_READING,
  SET_SENSOR_CONNECTED,
} from './mutation-types';
import { dataService } from '../shared/data';

Vue.use(Vuex)

const state = () => ({
  samples: [], 
  folders: [],
  lights: [],
  panelTemperatures: [],
  selectedFolder : null,
  accessToken: null,
  refreshToken: null,
  isAdmin: false, 
  light: null,
  panelTemperature: null,
  isSensorReading: false,  
  isSensorConnected: false,
});

const mutations = {
  [ADD_SAMPLE](state, sample) {
    state.samples.unshift(sample); 
  },
  [UPDATE_SAMPLE](state, sample) {
    const index = state.samples.findIndex(h => h.id === sample.id);
    state.samples.splice(index, 1, sample);
    state.samples = [...state.samples];
  },
  [GET_SAMPLES](state, samples) {
    state.samples = samples;
  },
  [DELETE_SAMPLE](state, sampleId) {
    state.samples = state.samples.filter(p => p.id !== sampleId);
  },
  [SET_TOKEN](state, token) {
    state.accessToken = token;
  },
  [SET_ADMIN](state, isAdmin) {
    state.isAdmin = isAdmin;
  },
  [GET_FOLDERS](state, folders) {
    state.folders = folders;
  },
  [CREATE_FOLDER](state, folder) {
    state.folders.unshift(folder); 
  },
  [SELECT_FOLDER](state, folder) {
    state.selectedFolder = folder; 
  },
 
  [ADD_LIGHT](state, light) {
    state.lights.push(light); 
  },  
  [ADD_PANEL_TEMPERATURE](state, temperature) {
    state.panelTemperatures.push(temperature); 
  },
  [CLEAR_LIGHTS](state) {
    state.lights = []; 
  },
  [CLEAR_PANEL_TEMPERATURES](state) {
    state.panelTemperatures = []; 
  },

  [SET_LIGHT](state, light) {
    state.light = light; 
  },
  [SET_PANEL_TEMPERATURE](state, temperature) {
    state.panelTemperature = temperature; 
    if(state.isSensorReading)
    {
      state.panelTemperatures.push(temperature); 
    }
  },

  [SET_SENSOR_READING](state, isOn)
  {
    state.isSensorReading = isOn; 
  },

  [SET_SENSOR_CONNECTED](state, isOn)
  {
    state.isSensorConnected = isOn;
  }
}

const actions = {
  async getSamplesAction({ commit, state }) {
    var folderId = 0;
    if(state.selectedFolder?.rowKey == null)
    {
      if(state.folders.lenght === 0)      
      {
         await this.getFoldersAction({commit : commit});
      }
      
      if(state.folders.lenght === 0 || state.folders[0]?.rowKey == null) 
        return;

      folderId = state.folders[0].rowKey;
      commit(SELECT_FOLDER, state.folders[0]);              
    }
    else
    {
      folderId = state.selectedFolder.rowKey;
    }    
    const sampes = await dataService.getSamples(folderId);
    commit(GET_SAMPLES, sampes);
  },

  async getSampleDataAction({commit, state}, sampleId)
  {
    if(!state.selectedFolder)
      return;
    const folderId = state.selectedFolder.rowKey;
    const sample = await dataService.getSampleData(sampleId, folderId);
     commit(UPDATE_SAMPLE, sample);
  },

  async addSampleAction({commit, state}, sample) {   
    if(!state.selectedFolder)
      return;
    sample.folderId = state.selectedFolder.rowKey; 
    const addedSample = await dataService.addSample(sample);
    commit(ADD_SAMPLE, addedSample);
  },

  async updateSampleAction({commit, state}, sample){
    if(!state.selectedFolder)
      return;
    sample.folderId = state.selectedFolder.rowKey; 
    const updatedSample = await dataService.updateSample(sample);
    commit(UPDATE_SAMPLE, updatedSample);
  },

  async deleteSampleAction({commit, state}, sampleId){    
    if(!state.selectedFolder)
      return;
    const folderId = state.selectedFolder.rowKey; 
    const deletedSampleId = await dataService.deleteSample(sampleId, folderId);
    commit(DELETE_SAMPLE, deletedSampleId);
  },

  async getFoldersAction({ commit }) {
    const folders = await dataService.getUserFolders();
    commit(GET_FOLDERS, folders);
  },

  async createFolderAction({ commit }, folderName) {
    const folder = await dataService.createFolder(folderName);
    commit(CREATE_FOLDER, folder);    
  },

  async selectFolderAction({ commit }, folder) {    
    commit(SELECT_FOLDER, folder);
  },

  async getAccessToken({commit}, credentials){
    const tokens = await dataService.getTokens(credentials.username,credentials.password);
    commit(SET_TOKEN, tokens.accessToken);    
    if(dataService.isUserAdmin())
    {
      commit(SET_ADMIN, true);
    }
    return tokens.accessToken;
  },

  deleteAccessToken({commit}){  
    dataService.deleteToken();  
    commit(SET_TOKEN, null);        
  },

  setLightAction({ commit, state }, light) {    
    commit(SET_LIGHT, light);
    if(state.isSensorReading)
    {
      commit(ADD_LIGHT, light);       
    }
  },
  setPanelTemperatureAction({ commit, state }, temperature) {    
    commit(SET_PANEL_TEMPERATURE, temperature);
    if(state.isSensorReading)
    {
      commit(ADD_PANEL_TEMPERATURE, temperature);       
    }
  },

  setSensorReadingAction({commit},isOn)
  {
    commit(SET_SENSOR_READING,isOn);
  },
  clearLightsAction({commit}){
    commit(CLEAR_LIGHTS);
  },
  clearPanelTemperaturesAction({commit}){
    commit(CLEAR_PANEL_TEMPERATURES);
  },

  setSensorConnectedAction({commit}, isOn){
    commit(SET_SENSOR_CONNECTED, isOn);
  }
};

const getters = {
  getSampleById: state => id => state.samples.find(s => s.id === id),
  getSamplesByIds: state => ids => state.samples.filter(s => ids.includes( s.id )),
  getSensorLights: state => () => {
    return [...state.lights];
  },
  getAverageLight: state => () => {
      if(state.lights.lenght == 0)
      {
        return null;
      }
      else{
        return Math.round(state.lights.reduce((a,b) => a + b, 0) / state.lights.length);
      }
    },
    getAverageTemperature: state => () => {
      if(state.panelTemperatures.lenght == 0)
      {
        return null;
      }
      else{
        return Math.round(state.panelTemperatures.reduce((a,b) => a + b, 0) / state.panelTemperatures.length);
      }
    },
    getIsSensorConnected: state => () => state.isSensorConnected,
};

const modules = {};

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state,
  mutations,
  actions,
  getters,
  modules,
})
